import axios from 'axios';
import { environmentVariable, resolveEnvironmentVariable } from '@/lib/env';
import { installRequestID, installSignedRequestAuth, installTenantID } from '@/api/interceptors';

const getBrainstormHost = () => {
  const host = window.location.host;
  if (host.includes('stage.x.mooncamp.com')) {
    return host.replace('stage', 'stage-ai-chat');
  }
  return resolveEnvironmentVariable(environmentVariable.BRAINSTORM_HOST);
};

export const httpclient = axios.create({
  baseURL: `https://${getBrainstormHost()}/api/v1`,
  withCredentials: true,
});

const BrainstormClientPlugin = {
  install: (app, { store }) => {
    if (!store) {
      throw new Error('BrainstormClientPlugin requires a store instance.');
    }

    httpclient.interceptors.request.use(installRequestID);
    httpclient.interceptors.request.use(installTenantID(store));
    httpclient.interceptors.request.use(installSignedRequestAuth, (error) => Promise.reject(error));
  },
};

export default BrainstormClientPlugin;
